// extracted by mini-css-extract-plugin
export default {"root":"_1ly7q","left":"rdR12","left-side-item-wrapper":"_1caw4","leftSideItemWrapper":"_1caw4","right":"_3skza","right-side-item-wrapper":"_3QdwS","rightSideItemWrapper":"_3QdwS"};